import styled from 'styled-components';
import Footer from './Footer';
import Navigation from './Navigation';

const Layout = ({ children }) => {
 return (
  <Container color={window.location.pathname === '/about' ? '#FFF' : '#000'}>
   <Navigation
    color={window.location.pathname !== '/about' ? '#FFF' : '#000'}
   />
   {children}
   <Footer />
  </Container>
 );
};

export default Layout;
const Container = styled.div`
 width: 100vw;
 height: 100vh;
 text-align: center;
 background-color: ${(props) => props.color};
 #error-page {
  height: 50%;
  width: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 2rem;
 }
`;
